
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { SignOutButton } from "@/components/SignOutButton";
import { Logo } from "@/components/common/Logo";
import { UserRound } from "lucide-react";
import { useLocation } from "react-router-dom";

interface NavigationHeaderProps {
  onMenuToggle: () => void;
  menuOpen: boolean;
}

export function NavigationHeader({ onMenuToggle, menuOpen }: NavigationHeaderProps) {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path ? "text-primary" : "text-muted-foreground";
  };

  return (
    <>
      {/* Left side - Logo */}
      <div className="flex items-center space-x-4 flex-shrink-0">
        <Logo size="small" className="cursor-pointer" />
      </div>

      {/* Right side - Desktop only user actions */}
      <div className="hidden md:flex items-center space-x-2 flex-shrink-0">
        <div className="flex items-center gap-2">
          <Link
            to="/profile"
            className={`${isActive("/profile")} p-2 rounded-full hover:bg-muted transition-colors mobile-touch-target`}
          >
            <UserRound className="w-5 h-5" />
            <span className="sr-only">Profile</span>
          </Link>
          <SignOutButton />
        </div>
      </div>

      {/* Mobile menu button */}
      <Button
        variant="ghost"
        className="md:hidden flex-shrink-0 mobile-touch-target"
        onClick={onMenuToggle}
      >
        {menuOpen ? "Close" : "Menu"}
      </Button>
    </>
  );
}
